export default __webpack_public_path__ + "static/media/misc-pantry1-768w.635af2de.avif";